
/* injects from baggage-loader */

'use strict';

import AccountHomeComponent from './account.home.component';

const AccountHomePageModule = angular.module('account-home-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.home', {
        url: '/home',
        component: 'accountHome',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          investments: function(Investments) {
            return Investments.list();
          }
        }
      });
  })
  .component('accountHome', new AccountHomeComponent());

export default AccountHomePageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/home/account.home.module.js